/* global $ */

const $modules = $.$body.find('[data-module],.module');

// add class to last module
$modules.last().addClass('last-module');

// Accordions
$.$body
  .on('focus', '.module__accordion .js-accordion-button', (e) => {
    $(e.currentTarget).attr('aria-selected', true);
  })
  .on('blur', '.module__accordion .js-accordion-button', (e) => {
    $(e.currentTarget).attr('aria-selected', false);
  })
  .on('click', '.module__accordion .js-accordion-button', (e) => {
    e.preventDefault();
    // console.log('accordion open');

    const $button = $(e.currentTarget);
    const isExpanded = $button.attr('aria-expanded') === 'true';
    const $header = $button.closest('.accordion__headline');
    const $section = $header.next('.accordion__content');

    $button.attr('aria-expanded', !isExpanded);
    $section.attr('aria-hidden', isExpanded);

    if (!isExpanded) {
      const $rowAnchor = $header.closest('.accordion__single-row');
      window.scrollTo(0, $rowAnchor.offset().top - 95);
      // if (false && 'scrollIntoViewIfNeeded' in $rowAnchor.get(0)) {
      //   $rowAnchor.get(0).scrollIntoViewIfNeeded(false);
      // } else if (false && 'scrollIntoView' in $rowAnchor.get(0)) {
      //   $rowAnchor.get(0).scrollIntoView(true);
      // } else {
      //   window.scrollTo(0, $rowAnchor.offset().top - 95);
      // }
    }
  });

// $.$body.find('.select2-tax').each((i, el) => {
//   console.log(el, $(el).select2);
//   $(el).select2();
// });

// $.$body.on('change', '.index-checkbox', (e) => {
//   const $checkbox = $(e.currentTarget);
//   const itemvalue = $checkbox.val();
//   const isOn = $checkbox.prop('checked');
//   // const type = $checkbox.data('type');
//   const formvals = $checkbox
//     .closest('form')
//     .find('.index-page__checkboxes input')
//     .get()
//     .reduce((acc, node) => {
//       if (node.checked) {
//         acc.push({ name: node.name, value: node.value });
//       }
//       return acc;
//     }, []);
//   console.log(itemvalue, isOn, formvals);

//   const category = [];
//   const region = [];
//   formvals.forEach(({ name, value }) => {
//     if (value && name === 'region' && value !== 'Region') {
//       region.push(value);
//     } else if (value && name === 'category' && value !== 'Category') {
//       category.push(value);
//     }
//   });
//   const url = new URL(window.location.origin + window.location.pathname);
//   if (region.length) {
//     url.searchParams.set('region', region.join(','));
//   }
//   if (category.length) {
//     url.searchParams.set('category', category.join(','));
//   }
//   console.log(url);
//   window.location.replace(`${url}#filterform`);
// });

// function capitalize(str) {
//   return (
//     String(str)
//       .charAt(0)
//       .toUpperCase() + str.slice(1)
//   );
// }
$(document).ready(() => {
  $.$body.find('.select2-tax').each((i, el) => {
    const $el = window.$(el);
    const placeholder = 'All'; // capitalize($el.data('name'));
    $el
      .addClass('js-example-placeholder-multiple js-states form-control')
      .prop('multiple', true);
    $el
      .select2({
        multiple: true,
        placeholder,
      })
      .trigger('change');
  });

  $.$body.on('submit', '#filterform', (e) => {
    e.preventDefault();
    const formvals = $(e.currentTarget)
      .closest('form')
      .find('.index-page__dropdowns select')
      .get()
      .reduce((acc, select) => {
        const vals = $(select).val();
        const { name } = select;
        if (vals && vals.length) {
          vals.forEach((value) => {
            acc.push({ name, value });
          });
        }
        return acc;
      }, []);
    console.log(formvals);

    const category = [];
    const topics = [];
    formvals.forEach(({ name, value }) => {
      if (value && name === 'topics' && value !== 'Topics') {
        topics.push(value);
      } else if (value && name === 'category' && value !== 'Categories') {
        category.push(value);
      }
    });
    console.log(topics);
    const url = new URL(window.location.origin + window.location.pathname);
    if (topics.length) {
      url.searchParams.set('topics', topics.join(','));
    }
    if (category.length) {
      url.searchParams.set('category', category.join(','));
    }
    console.log(url);
    window.location.replace(`${url}#filterform`);
  });

  /*
  $.$body.on('change', '.index-page__dropdown select', (e) => {
    const $checkbox = $(e.currentTarget);
    // const itemvalue = $checkbox.val();
    // const type = $checkbox.data('type');
    const formvals = $checkbox
      .closest('form')
      .find('.index-page__dropdowns select')
      .get()
      .reduce((acc, select) => {
        const vals = $(select).val();
        const { name } = select;
        if (vals && vals.length) {
          vals.forEach((value) => {
            acc.push({ name, value });
          });
        }
        return acc;
      }, []);
    console.log(formvals);

    const category = [];
    const region = [];
    formvals.forEach(({ name, value }) => {
      if (value && name === 'topic' && value !== 'Topics') {
        region.push(value);
      } else if (value && name === 'category' && value !== 'Categories') {
        category.push(value);
      }
    });
    const url = new URL(window.location.origin + window.location.pathname);
    if (region.length) {
      url.searchParams.set('topic', region.join(','));
    }
    if (category.length) {
      url.searchParams.set('category', category.join(','));
    }
    console.log(url);
    window.location.replace(`${url}#filterform`);
  });
*/
});

// const gallery = {
//   currentImage: 0,
//   images: document.querySelectorAll('.featured-image__slide'),
//   scrollContainer: document.querySelector('.featured-image__slider'),
//   buttonPrev: document.querySelector(
//     '.featured-image__slider--button-previous',
//   ),
//   buttonNext: document.querySelector('.featured-image__slider--button-next'),

//   updateDisabledButtons: function() {
//     this.buttonPrev.disabled = !!(this.currentImage === 0);
//     this.buttonNext.disabled = !!(this.currentImage === this.images.length - 1);
//   },

//   scrollToCurrentImage: function() {
//     const currentImage = this.images[this.currentImage];
//     const container = this.scrollContainer;
//     const imagePositionCenter = Math.floor(
//       currentImage.offsetLeft -
//         (container.offsetWidth - currentImage.offsetWidth) / 2,
//     );

//     // we need to toggle the CSS scroll-snap
//     // otherwise the gallery occassionally doesn't slide to the correct new position
//     // this doesn't seem to be an issue if we scroll-snap to the left
//     container.classList.remove('-scroll-snap');
//     container.scrollLeft = imagePositionCenter;
//     setTimeout(() => {
//       container.classList.add('-scroll-snap');
//     }, 500);
//   },

//   navigate: function(_direction) {
//     if (
//       (_direction === -1 && this.currentImage > 0) ||
//       (_direction === 1 && this.currentImage < this.images.length - 1)
//     ) {
//       this.images[this.currentImage].classList.remove('-current');
//       this.currentImage += _direction;
//       this.images[this.currentImage].classList.add('-current');
//       this.scrollToCurrentImage();
//       this.updateDisabledButtons();
//     }
//   },

//   init: function(node) {
//     console.log(this, node);
//     this.scrollContainer.scrollLeft = 0;

//     document
//       .querySelector('.featured-image__slider--button-previous')
//       .addEventListener('click', () => {
//         gallery.navigate(-1);
//       });

//     document
//       .querySelector('.featured-image__slider--button-next')
//       .addEventListener('click', () => {
//         gallery.navigate(1);
//       });
//   },
// };

// // just waiting for the placeholder images to load ...
// setTimeout(() => {
//   Array.from(
//     document.querySelectorAll('.featured-image__slider--container'),
//   ).forEach((node) => {
//     gallery.init(node);
//   });
// }, 1000);
